import React, { Component } from 'react';

class IconLine extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="4"
                fill="none"
                viewBox="0 0 200 4"
            >
                <path
                    stroke="#1D53A5"
                    strokeLinecap="round"
                    strokeWidth="4"
                    d="M2 2L198 2"
                ></path>
            </svg>
        );
    }
}

export default IconLine;